import HomeView from "../components/HomeView";
import { SidebarProvider } from "@/components/ui/sidebar";
import ChatPage from "@/modules/Chat/pages/ChatPage";
import CMSPage from "@/modules/CMS/pages/CMSPage";
import DocumentsPage from "@/modules/Documents/pages/DocumentsPage";
import FeedbackPage from "@/modules/Feedback/pages/FeedbackPage";
import { AppSidebar } from "@/modules/Home/components/AppSidebar";
import { SiteHeader } from "@/modules/Home/components/SiteHeader";
import LeasesPage from "@/modules/Leases/pages/LeasesPage";

import NotificationsPage from "@/modules/Notifications/pages/NotificationsPage";
import PaymentsPage from "@/modules/Payments/pages/PaymentsPage";
import PropertiesPage from "@/modules/Properties/pages/PropertiesPage";
import PropertyPage from "@/modules/Properties/pages/PropertyPage/PropertyPage";
import ReportsPage from "@/modules/Reports/pages/ReportsPage";
import RequestsPage from "@/modules/Requests/pages/RequestsPage";
import SecurityPage from "@/modules/Security/pages/SecurityPage";
import SupportPage from "@/modules/Support/pages/SupportPage";
import UserProfile from "@/modules/Users/pages/UserProfile/UserProfile";
import UsersPage from "@/modules/Users/pages/UsersPage";
import { Navigate, Route, Routes } from "react-router-dom";
import LeaseCreatePage from "@/modules/Leases/pages/LeaseCreatePage";
import { SystemSettings } from "@/modules/SystemSettings/SystemSettings";

export const HomePage = () => {
  return (
    <div className="[--header-height:calc(theme(spacing.14))]">
      <SidebarProvider className="flex flex-col">
        <SiteHeader />
        <div className="flex flex-1">
          <AppSidebar />
          <main className="flex-1 overflow-y-auto">
            <Routes>
              <Route index element={<HomeView />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="users/:userUUID?" element={<UserProfile />} />
              <Route path="properties" element={<PropertiesPage />} />
              <Route path="properties/:propertyUUID" element={<PropertyPage />} />
              <Route path="properties/:propertyUUID/leases/*" element={<PropertyPage />} />
              <Route path="system-settings/*" element={<SystemSettings />} />
              <Route path="properties/:propertyUUID/documents/*" element={<PropertyPage />} />
              <Route path="properties/:propertyUUID/service-requests/*" element={<PropertyPage />} />
              <Route path="leases" element={<LeasesPage />} />
              <Route path="leases/create" element={<LeaseCreatePage />} />
              <Route path="documents/*" element={<DocumentsPage />} />
              <Route path="payments/*" element={<PaymentsPage />} />
              <Route path="requests" element={<RequestsPage />} />
              <Route path="chat" element={<ChatPage />} />
              <Route path="notifications" element={<NotificationsPage />} />
              <Route path="feedback" element={<FeedbackPage />} />
              <Route path="support" element={<SupportPage />} />
              <Route path="security" element={<SecurityPage />} />
              <Route path="reports" element={<ReportsPage />} />
              <Route path="cms" element={<CMSPage />} />
              <Route path="*" element={<Navigate to="" replace />} />
            </Routes>
          </main>
        </div>
      </SidebarProvider>
    </div>
  );
};
export default HomePage;
